module.exports = __webpack_public_path__ + "img/warning.ab00e428.svg";